<script setup lang="ts">
import MButton from "../MButton";
import MLayoutStack from "../MLayoutStack";
defineProps<{
  label: string;
}>();
</script>
<template>
  <m-button class="nhs-button" label="">
    <m-layout-stack class="items-center justify-center" horizontal>
      <svg
        width="50"
        height="20"
        viewBox="0 0 50 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="nhs-logo-svg"
      >
        <title id="nhs-logo-svg">NHS</title>
        <path
          d="M49.6667 20V0H0V20H49.6667ZM20 1.93333L16.5407 18.0296H11.163L7.77778 6.91852H7.73333L5.51111 18.0296H1.4L4.85926 1.93333H10.2519L13.5704 13.0963H13.6148L15.8889 1.93333H20ZM35.3852 1.93333L32 18.0296H27.6667L29.1037 11.1111H23.9778L22.5407 18.0074H18.2074L21.5704 1.91111H25.9259L24.6519 8.06667H29.7704L31.0444 1.91111L35.3852 1.93333ZM47.837 2.37037L46.7926 5.57778C45.6737 5.06432 44.453 4.81106 43.2222 4.83704C41.5111 4.83704 40.1185 5.08889 40.1185 6.38519C40.1185 8.66667 46.4 7.81482 46.4 12.7037C46.4 17.1481 42.2519 18.3037 38.4963 18.3037C36.7966 18.2623 35.1111 17.9831 33.4889 17.4741L34.5111 14.2C35.7432 14.8315 37.112 15.1495 38.4963 15.1259C39.837 15.1259 41.9481 14.8667 41.9481 13.2074C41.9481 10.6222 35.6667 11.5926 35.6667 7.05185C35.6667 2.8963 39.3259 1.65185 42.8741 1.65185C44.5605 1.58081 46.2449 1.83222 47.837 2.39259V2.37037Z"
          fill="white"
        />
      </svg>
      <span>{{ label }}</span>
    </m-layout-stack>
  </m-button>
</template>
<style lang="scss">
.nhs-button {
  $nhsColour: #005eb8;
  $nhsColourHover: #003f7b;

  > .medicus-button {
    background-color: $nhsColour !important;
    border-color: $nhsColour !important;
    box-shadow: inset 0px -3px 0px #003087;

    font-family: "Arial";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;

    display: flex;
    align-items: center;
    text-align: center;

    color: #ffffff;

    &:hover {
      background-color: $nhsColourHover !important;
      border-color: $nhsColourHover !important;
    }
  }
}
</style>
